@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;


.button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 93px;
  height: 32px;
  color: v.$palette-blue;
  @include t.text(14px, 22px, 600);
  background-color: v.$palette-blue-light-2;
  border: none;
  box-shadow: none;
  margin: 0;
  padding: 0;
  border-radius: 8px;
}

.icon {
  margin-right: 8px;
  transform: rotate(180deg);
  path {
    stroke: v.$palette-blue;
  }
}
